/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type PaymentsPage_viewer$ref = any;
export type queries_PaymentsPage_QueryVariables = {};
export type queries_PaymentsPage_QueryResponse = {
    readonly viewer: ({
        readonly id: string | null;
        readonly " $fragmentRefs": PaymentsPage_viewer$ref;
    }) | null;
};
export type queries_PaymentsPage_Query = {
    readonly response: queries_PaymentsPage_QueryResponse;
    readonly variables: queries_PaymentsPage_QueryVariables;
};



/*
query queries_PaymentsPage_Query {
  viewer {
    id
    ...PaymentsPage_viewer
  }
}

fragment PaymentsPage_viewer on Viewer {
  id
  user {
    id
    role
    ...AccountEditPaymentDialog_user
    ...AccountAddPaymentDialog_user
    paymentIdDefault
    paymentDefault {
      last4
      expYear
      expMonth
      billingAddressUuid
      paymentId
      brand
      nickname
      id
    }
    addressBook {
      entries(first: 100) {
        edges {
          node {
            id
            address {
              id
              addressId
              addressLineOne
              addressLineTwo
              city
              country
              firstName
              lastName
              nickname
              phoneNumber
              recipientBirthDate
              specialInstructions
              state
              street
              zip
            }
            __typename
          }
          cursor
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
      id
    }
    stripePaymentCollection {
      id
      totalNumberOfStripePayment
      entries(first: 1000) {
        edges {
          node {
            stripePayment {
              ...StripePaymentV3_stripePayment
              ...AccountEditPaymentDialog_stripePayment
              id
              last4
              nickname
              expYear
              expMonth
              billingAddressUuid
              paymentId
              brand
            }
            id
            __typename
          }
          cursor
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
}

fragment AccountEditPaymentDialog_user on User {
  ...EditPaymentDialogContent_user
  id
  shippingAddressIdDefault
  paymentIdDefault
  cart {
    id
    shippingAddress {
      addressId
      id
    }
    paymentInfo {
      paymentId
      id
    }
  }
  stripePaymentCollection {
    id
    entries(first: 1000) {
      edges {
        cursor
        node {
          id
          stripePayment {
            id
            name
            last4
            expYear
            expMonth
            billingAddressUuid
            paymentId
            brand
            nickname
            billingAddress {
              id
              firstName
              lastName
              street
              addressLineOne
              addressLineTwo
              city
              state
              zip
              recipientBirthDate
              addressId
              country
              phoneNumber
              emailAddress
              specialInstructions
              nickname
              companyName
            }
          }
          __typename
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
  shippingAddressBook {
    id
    entries(first: 100) {
      edges {
        node {
          id
          address {
            id
            addressId
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
  addressBook {
    id
    entries(first: 100) {
      edges {
        node {
          id
          address {
            id
            addressId
            addressLineOne
            addressLineTwo
            city
            country
            firstName
            lastName
            companyName
            nickname
            phoneNumber
            recipientBirthDate
            state
            street
            zip
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}

fragment AccountAddPaymentDialog_user on User {
  shippingAddressIdDefault
  paymentIdDefault
  cart {
    id
    shippingAddress {
      addressId
      id
      lastName
      firstName
      street
      addressLineOne
      addressLineTwo
      city
      state
      zip
    }
  }
  addressBook {
    id
    entries(first: 100) {
      edges {
        node {
          id
          address {
            addressId
            lastName
            firstName
            street
            addressLineOne
            addressLineTwo
            city
            state
            zip
            phoneNumber
            id
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
  shippingAddressBook {
    id
  }
  stripePaymentCollection {
    id
    totalNumberOfStripePayment
    totalNumberOfStripePayments
    entries(first: 1000) {
      edges {
        cursor
        node {
          id
          stripePayment {
            id
            name
            last4
            expYear
            expMonth
            billingAddressUuid
            paymentId
            object
            brand
            dynamicLast4
            funding
            tokenizationMethod
            billingAddress {
              id
              firstName
              lastName
              street
              addressLineOne
              addressLineTwo
              city
              state
              zip
              recipientBirthDate
              addressId
              country
              phoneNumber
              emailAddress
              specialInstructions
              nickname
              companyName
            }
            nickname
          }
          __typename
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}

fragment StripePaymentV3_stripePayment on StripePayment {
  ...AccountEditPaymentDialog_stripePayment
  id
  paymentId
  nickname
  brand
  last4
  expYear
  expMonth
  billingAddress {
    id
    addressId
    addressLineOne
    addressLineTwo
    city
    country
    firstName
    lastName
    companyName
    nickname
    phoneNumber
    recipientBirthDate
    state
    street
    zip
  }
  billingAddressUuid
}

fragment AccountEditPaymentDialog_stripePayment on StripePayment {
  ...EditPaymentDialogContent_stripePayment
  id
  last4
  nickname
  expYear
  expMonth
  billingAddressUuid
  paymentId
  brand
  billingAddress {
    id
    addressId
    addressLineOne
    addressLineTwo
    city
    country
    firstName
    lastName
    companyName
    nickname
    phoneNumber
    recipientBirthDate
    state
    street
    zip
  }
}

fragment EditPaymentDialogContent_stripePayment on StripePayment {
  ...EditPaymentInformation_stripePayment
  id
  last4
  nickname
  expYear
  expMonth
  billingAddressUuid
  paymentId
  brand
  billingAddress {
    id
    addressId
    addressLineOne
    addressLineTwo
    city
    country
    firstName
    lastName
    companyName
    nickname
    phoneNumber
    recipientBirthDate
    state
    street
    zip
  }
}

fragment EditPaymentInformation_stripePayment on StripePayment {
  id
  last4
  nickname
  expYear
  expMonth
  billingAddressUuid
  paymentId
  brand
  billingAddress {
    id
    addressId
    addressLineOne
    addressLineTwo
    city
    country
    firstName
    lastName
    companyName
    nickname
    phoneNumber
    recipientBirthDate
    state
    street
    zip
  }
}

fragment EditPaymentDialogContent_user on User {
  ...AccountAddressBook_user
  ...AccountAddAddressForm_user
  addressBook {
    id
    entries(first: 100) {
      edges {
        node {
          id
          address {
            id
            addressId
            addressLineOne
            addressLineTwo
            city
            country
            firstName
            lastName
            companyName
            nickname
            phoneNumber
            recipientBirthDate
            state
            street
            zip
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}

fragment AccountAddressBook_user on User {
  id
  addressBook {
    totalNumberOfAddresses
    entries(first: 100) {
      edges {
        node {
          id
          address {
            id
            ...AddressBookItem_address
            addressId
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    id
  }
  shippingAddressBook {
    totalNumberOfAddresses
    entries(first: 100) {
      edges {
        node {
          id
          address {
            id
            ...AddressBookItem_address
            addressId
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    id
  }
}

fragment AccountAddAddressForm_user on User {
  shippingAddressIdDefault
  addressBook {
    id
  }
}

fragment AddressBookItem_address on Address {
  ...AddressBookItemText_address
  ...AddressBookItemTextMobile_address
  id
  addressId
  addressLineOne
  addressLineTwo
  city
  companyName
  country
  firstName
  lastName
  specialInstructions
  phoneNumber
  recipientBirthDate
  state
  zip
  nickname
}

fragment AddressBookItemText_address on Address {
  id
  addressId
  ...AddressBookItemStreet_address
  ...AddressBookItemName_address
}

fragment AddressBookItemTextMobile_address on Address {
  addressId
  addressLineOne
  addressLineTwo
  city
  companyName
  country
  firstName
  id
  lastName
  specialInstructions
  phoneNumber
  recipientBirthDate
  state
  zip
  nickname
}

fragment AddressBookItemStreet_address on Address {
  id
  addressId
  addressLineOne
  addressLineTwo
  city
  state
  zip
}

fragment AddressBookItemName_address on Address {
  nickname
  companyName
  firstName
  lastName
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "totalNumberOfAddresses",
        "args": null,
        "storageKey": null
    } as any), v2 = [
        ({
            "kind": "Literal",
            "name": "first",
            "value": 100,
            "type": "Int"
        } as any)
    ], v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "companyName",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "addressLineOne",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "addressLineTwo",
        "args": null,
        "storageKey": null
    } as any), v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "city",
        "args": null,
        "storageKey": null
    } as any), v7 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "state",
        "args": null,
        "storageKey": null
    } as any), v8 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "zip",
        "args": null,
        "storageKey": null
    } as any), v9 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "nickname",
        "args": null,
        "storageKey": null
    } as any), v10 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "addressId",
        "args": null,
        "storageKey": null
    } as any), v11 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "firstName",
        "args": null,
        "storageKey": null
    } as any), v12 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "lastName",
        "args": null,
        "storageKey": null
    } as any), v13 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "country",
        "args": null,
        "storageKey": null
    } as any), v14 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "specialInstructions",
        "args": null,
        "storageKey": null
    } as any), v15 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "phoneNumber",
        "args": null,
        "storageKey": null
    } as any), v16 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "recipientBirthDate",
        "args": null,
        "storageKey": null
    } as any), v17 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "street",
        "args": null,
        "storageKey": null
    } as any), v18 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "__typename",
        "args": null,
        "storageKey": null
    } as any), v19 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "cursor",
        "args": null,
        "storageKey": null
    } as any), v20 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "pageInfo",
        "storageKey": null,
        "args": null,
        "concreteType": "PageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v21 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "paymentId",
        "args": null,
        "storageKey": null
    } as any), v22 = [
        ({
            "kind": "Literal",
            "name": "first",
            "value": 1000,
            "type": "Int"
        } as any)
    ], v23 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "brand",
        "args": null,
        "storageKey": null
    } as any), v24 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "last4",
        "args": null,
        "storageKey": null
    } as any), v25 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "expYear",
        "args": null,
        "storageKey": null
    } as any), v26 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "expMonth",
        "args": null,
        "storageKey": null
    } as any), v27 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "billingAddressUuid",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "queries_PaymentsPage_Query",
            "type": "Root",
            "metadata": null,
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "FragmentSpread",
                            "name": "PaymentsPage_viewer",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "queries_PaymentsPage_Query",
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                (v0 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "role",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "addressBook",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "AddressBook",
                                    "plural": false,
                                    "selections": [
                                        (v1 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "entries",
                                            "storageKey": "entries(first:100)",
                                            "args": (v2 /*: any*/),
                                            "concreteType": "AddressBookEntryConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "edges",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "AddressBookEntryEdge",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "node",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "AddressBookEntry",
                                                            "plural": false,
                                                            "selections": [
                                                                (v0 /*: any*/),
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "address",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "Address",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v3 /*: any*/),
                                                                        (v0 /*: any*/),
                                                                        (v4 /*: any*/),
                                                                        (v5 /*: any*/),
                                                                        (v6 /*: any*/),
                                                                        (v7 /*: any*/),
                                                                        (v8 /*: any*/),
                                                                        (v9 /*: any*/),
                                                                        (v10 /*: any*/),
                                                                        (v11 /*: any*/),
                                                                        (v12 /*: any*/),
                                                                        (v13 /*: any*/),
                                                                        (v14 /*: any*/),
                                                                        (v15 /*: any*/),
                                                                        (v16 /*: any*/),
                                                                        (v17 /*: any*/)
                                                                    ]
                                                                },
                                                                (v18 /*: any*/)
                                                            ]
                                                        },
                                                        (v19 /*: any*/)
                                                    ]
                                                },
                                                (v20 /*: any*/)
                                            ]
                                        },
                                        {
                                            "kind": "LinkedHandle",
                                            "alias": null,
                                            "name": "entries",
                                            "args": (v2 /*: any*/),
                                            "handle": "connection",
                                            "key": "AddressBook_entries",
                                            "filters": null
                                        },
                                        (v0 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "shippingAddressBook",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "AddressBook",
                                    "plural": false,
                                    "selections": [
                                        (v1 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "entries",
                                            "storageKey": "entries(first:100)",
                                            "args": (v2 /*: any*/),
                                            "concreteType": "AddressBookEntryConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "edges",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "AddressBookEntryEdge",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "node",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "AddressBookEntry",
                                                            "plural": false,
                                                            "selections": [
                                                                (v0 /*: any*/),
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "address",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "Address",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v9 /*: any*/),
                                                                        (v0 /*: any*/),
                                                                        (v4 /*: any*/),
                                                                        (v5 /*: any*/),
                                                                        (v6 /*: any*/),
                                                                        (v7 /*: any*/),
                                                                        (v8 /*: any*/),
                                                                        (v10 /*: any*/),
                                                                        (v3 /*: any*/),
                                                                        (v11 /*: any*/),
                                                                        (v12 /*: any*/),
                                                                        (v13 /*: any*/),
                                                                        (v14 /*: any*/),
                                                                        (v15 /*: any*/),
                                                                        (v16 /*: any*/)
                                                                    ]
                                                                },
                                                                (v18 /*: any*/)
                                                            ]
                                                        },
                                                        (v19 /*: any*/)
                                                    ]
                                                },
                                                (v20 /*: any*/)
                                            ]
                                        },
                                        {
                                            "kind": "LinkedHandle",
                                            "alias": null,
                                            "name": "entries",
                                            "args": (v2 /*: any*/),
                                            "handle": "connection",
                                            "key": "ShippingAddressBook_entries",
                                            "filters": null
                                        },
                                        (v0 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "shippingAddressIdDefault",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "paymentIdDefault",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "cart",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Cart",
                                    "plural": false,
                                    "selections": [
                                        (v0 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "shippingAddress",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Address",
                                            "plural": false,
                                            "selections": [
                                                (v10 /*: any*/),
                                                (v0 /*: any*/),
                                                (v12 /*: any*/),
                                                (v11 /*: any*/),
                                                (v17 /*: any*/),
                                                (v4 /*: any*/),
                                                (v5 /*: any*/),
                                                (v6 /*: any*/),
                                                (v7 /*: any*/),
                                                (v8 /*: any*/)
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "paymentInfo",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "StripePayment",
                                            "plural": false,
                                            "selections": [
                                                (v21 /*: any*/),
                                                (v0 /*: any*/)
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "stripePaymentCollection",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "StripePaymentCollection",
                                    "plural": false,
                                    "selections": [
                                        (v0 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "entries",
                                            "storageKey": "entries(first:1000)",
                                            "args": (v22 /*: any*/),
                                            "concreteType": "StripePaymentCollectionEntryConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "edges",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "StripePaymentCollectionEntryEdge",
                                                    "plural": true,
                                                    "selections": [
                                                        (v19 /*: any*/),
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "node",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "StripePaymentCollectionEntry",
                                                            "plural": false,
                                                            "selections": [
                                                                (v0 /*: any*/),
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "stripePayment",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "StripePayment",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v23 /*: any*/),
                                                                        (v0 /*: any*/),
                                                                        (v24 /*: any*/),
                                                                        (v25 /*: any*/),
                                                                        (v26 /*: any*/),
                                                                        (v27 /*: any*/),
                                                                        (v21 /*: any*/),
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "name",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        (v9 /*: any*/),
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "billingAddress",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "Address",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v8 /*: any*/),
                                                                                (v0 /*: any*/),
                                                                                (v12 /*: any*/),
                                                                                (v17 /*: any*/),
                                                                                (v4 /*: any*/),
                                                                                (v5 /*: any*/),
                                                                                (v6 /*: any*/),
                                                                                (v7 /*: any*/),
                                                                                (v11 /*: any*/),
                                                                                (v16 /*: any*/),
                                                                                (v10 /*: any*/),
                                                                                (v13 /*: any*/),
                                                                                (v15 /*: any*/),
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "alias": null,
                                                                                    "name": "emailAddress",
                                                                                    "args": null,
                                                                                    "storageKey": null
                                                                                },
                                                                                (v14 /*: any*/),
                                                                                (v9 /*: any*/),
                                                                                (v3 /*: any*/)
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "object",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "dynamicLast4",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "funding",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "tokenizationMethod",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        }
                                                                    ]
                                                                },
                                                                (v18 /*: any*/)
                                                            ]
                                                        }
                                                    ]
                                                },
                                                (v20 /*: any*/)
                                            ]
                                        },
                                        {
                                            "kind": "LinkedHandle",
                                            "alias": null,
                                            "name": "entries",
                                            "args": (v22 /*: any*/),
                                            "handle": "connection",
                                            "key": "StripePaymentCollection_entries",
                                            "filters": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "totalNumberOfStripePayment",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "totalNumberOfStripePayments",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "paymentDefault",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "StripePayment",
                                    "plural": false,
                                    "selections": [
                                        (v24 /*: any*/),
                                        (v25 /*: any*/),
                                        (v26 /*: any*/),
                                        (v27 /*: any*/),
                                        (v21 /*: any*/),
                                        (v23 /*: any*/),
                                        (v9 /*: any*/),
                                        (v0 /*: any*/)
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "queries_PaymentsPage_Query",
            "id": null,
            "text": "query queries_PaymentsPage_Query {\n  viewer {\n    id\n    ...PaymentsPage_viewer\n  }\n}\n\nfragment PaymentsPage_viewer on Viewer {\n  id\n  user {\n    id\n    role\n    ...AccountEditPaymentDialog_user\n    ...AccountAddPaymentDialog_user\n    paymentIdDefault\n    paymentDefault {\n      last4\n      expYear\n      expMonth\n      billingAddressUuid\n      paymentId\n      brand\n      nickname\n      id\n    }\n    addressBook {\n      entries(first: 100) {\n        edges {\n          node {\n            id\n            address {\n              id\n              addressId\n              addressLineOne\n              addressLineTwo\n              city\n              country\n              firstName\n              lastName\n              nickname\n              phoneNumber\n              recipientBirthDate\n              specialInstructions\n              state\n              street\n              zip\n            }\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n      id\n    }\n    stripePaymentCollection {\n      id\n      totalNumberOfStripePayment\n      entries(first: 1000) {\n        edges {\n          node {\n            stripePayment {\n              ...StripePaymentV3_stripePayment\n              ...AccountEditPaymentDialog_stripePayment\n              id\n              last4\n              nickname\n              expYear\n              expMonth\n              billingAddressUuid\n              paymentId\n              brand\n            }\n            id\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n  }\n}\n\nfragment AccountEditPaymentDialog_user on User {\n  ...EditPaymentDialogContent_user\n  id\n  shippingAddressIdDefault\n  paymentIdDefault\n  cart {\n    id\n    shippingAddress {\n      addressId\n      id\n    }\n    paymentInfo {\n      paymentId\n      id\n    }\n  }\n  stripePaymentCollection {\n    id\n    entries(first: 1000) {\n      edges {\n        cursor\n        node {\n          id\n          stripePayment {\n            id\n            name\n            last4\n            expYear\n            expMonth\n            billingAddressUuid\n            paymentId\n            brand\n            nickname\n            billingAddress {\n              id\n              firstName\n              lastName\n              street\n              addressLineOne\n              addressLineTwo\n              city\n              state\n              zip\n              recipientBirthDate\n              addressId\n              country\n              phoneNumber\n              emailAddress\n              specialInstructions\n              nickname\n              companyName\n            }\n          }\n          __typename\n        }\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n  shippingAddressBook {\n    id\n    entries(first: 100) {\n      edges {\n        node {\n          id\n          address {\n            id\n            addressId\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n  addressBook {\n    id\n    entries(first: 100) {\n      edges {\n        node {\n          id\n          address {\n            id\n            addressId\n            addressLineOne\n            addressLineTwo\n            city\n            country\n            firstName\n            lastName\n            companyName\n            nickname\n            phoneNumber\n            recipientBirthDate\n            state\n            street\n            zip\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n}\n\nfragment AccountAddPaymentDialog_user on User {\n  shippingAddressIdDefault\n  paymentIdDefault\n  cart {\n    id\n    shippingAddress {\n      addressId\n      id\n      lastName\n      firstName\n      street\n      addressLineOne\n      addressLineTwo\n      city\n      state\n      zip\n    }\n  }\n  addressBook {\n    id\n    entries(first: 100) {\n      edges {\n        node {\n          id\n          address {\n            addressId\n            lastName\n            firstName\n            street\n            addressLineOne\n            addressLineTwo\n            city\n            state\n            zip\n            phoneNumber\n            id\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n  shippingAddressBook {\n    id\n  }\n  stripePaymentCollection {\n    id\n    totalNumberOfStripePayment\n    totalNumberOfStripePayments\n    entries(first: 1000) {\n      edges {\n        cursor\n        node {\n          id\n          stripePayment {\n            id\n            name\n            last4\n            expYear\n            expMonth\n            billingAddressUuid\n            paymentId\n            object\n            brand\n            dynamicLast4\n            funding\n            tokenizationMethod\n            billingAddress {\n              id\n              firstName\n              lastName\n              street\n              addressLineOne\n              addressLineTwo\n              city\n              state\n              zip\n              recipientBirthDate\n              addressId\n              country\n              phoneNumber\n              emailAddress\n              specialInstructions\n              nickname\n              companyName\n            }\n            nickname\n          }\n          __typename\n        }\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n}\n\nfragment StripePaymentV3_stripePayment on StripePayment {\n  ...AccountEditPaymentDialog_stripePayment\n  id\n  paymentId\n  nickname\n  brand\n  last4\n  expYear\n  expMonth\n  billingAddress {\n    id\n    addressId\n    addressLineOne\n    addressLineTwo\n    city\n    country\n    firstName\n    lastName\n    companyName\n    nickname\n    phoneNumber\n    recipientBirthDate\n    state\n    street\n    zip\n  }\n  billingAddressUuid\n}\n\nfragment AccountEditPaymentDialog_stripePayment on StripePayment {\n  ...EditPaymentDialogContent_stripePayment\n  id\n  last4\n  nickname\n  expYear\n  expMonth\n  billingAddressUuid\n  paymentId\n  brand\n  billingAddress {\n    id\n    addressId\n    addressLineOne\n    addressLineTwo\n    city\n    country\n    firstName\n    lastName\n    companyName\n    nickname\n    phoneNumber\n    recipientBirthDate\n    state\n    street\n    zip\n  }\n}\n\nfragment EditPaymentDialogContent_stripePayment on StripePayment {\n  ...EditPaymentInformation_stripePayment\n  id\n  last4\n  nickname\n  expYear\n  expMonth\n  billingAddressUuid\n  paymentId\n  brand\n  billingAddress {\n    id\n    addressId\n    addressLineOne\n    addressLineTwo\n    city\n    country\n    firstName\n    lastName\n    companyName\n    nickname\n    phoneNumber\n    recipientBirthDate\n    state\n    street\n    zip\n  }\n}\n\nfragment EditPaymentInformation_stripePayment on StripePayment {\n  id\n  last4\n  nickname\n  expYear\n  expMonth\n  billingAddressUuid\n  paymentId\n  brand\n  billingAddress {\n    id\n    addressId\n    addressLineOne\n    addressLineTwo\n    city\n    country\n    firstName\n    lastName\n    companyName\n    nickname\n    phoneNumber\n    recipientBirthDate\n    state\n    street\n    zip\n  }\n}\n\nfragment EditPaymentDialogContent_user on User {\n  ...AccountAddressBook_user\n  ...AccountAddAddressForm_user\n  addressBook {\n    id\n    entries(first: 100) {\n      edges {\n        node {\n          id\n          address {\n            id\n            addressId\n            addressLineOne\n            addressLineTwo\n            city\n            country\n            firstName\n            lastName\n            companyName\n            nickname\n            phoneNumber\n            recipientBirthDate\n            state\n            street\n            zip\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n}\n\nfragment AccountAddressBook_user on User {\n  id\n  addressBook {\n    totalNumberOfAddresses\n    entries(first: 100) {\n      edges {\n        node {\n          id\n          address {\n            id\n            ...AddressBookItem_address\n            addressId\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    id\n  }\n  shippingAddressBook {\n    totalNumberOfAddresses\n    entries(first: 100) {\n      edges {\n        node {\n          id\n          address {\n            id\n            ...AddressBookItem_address\n            addressId\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    id\n  }\n}\n\nfragment AccountAddAddressForm_user on User {\n  shippingAddressIdDefault\n  addressBook {\n    id\n  }\n}\n\nfragment AddressBookItem_address on Address {\n  ...AddressBookItemText_address\n  ...AddressBookItemTextMobile_address\n  id\n  addressId\n  addressLineOne\n  addressLineTwo\n  city\n  companyName\n  country\n  firstName\n  lastName\n  specialInstructions\n  phoneNumber\n  recipientBirthDate\n  state\n  zip\n  nickname\n}\n\nfragment AddressBookItemText_address on Address {\n  id\n  addressId\n  ...AddressBookItemStreet_address\n  ...AddressBookItemName_address\n}\n\nfragment AddressBookItemTextMobile_address on Address {\n  addressId\n  addressLineOne\n  addressLineTwo\n  city\n  companyName\n  country\n  firstName\n  id\n  lastName\n  specialInstructions\n  phoneNumber\n  recipientBirthDate\n  state\n  zip\n  nickname\n}\n\nfragment AddressBookItemStreet_address on Address {\n  id\n  addressId\n  addressLineOne\n  addressLineTwo\n  city\n  state\n  zip\n}\n\nfragment AddressBookItemName_address on Address {\n  nickname\n  companyName\n  firstName\n  lastName\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'eb710095b7e333198b0d414ad5a486fd';
export default node;
